import React from 'react';
import PropTypes from 'prop-types';

const ButtonContent = function ButtonContent({ children, icon }) {
  return (
    <span
      style={{
        paddingRight: 10,
        fontWeight: 500,
        paddingLeft: icon ? 0 : 10,
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      {children}
    </span>
  );
};

ButtonContent.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
};
ButtonContent.defaultProps = {
  children: null,
  icon: '',
};

export default ButtonContent;
